<template>
  <div>

    <Modal
      :width="623"
      :visible="previewVisible"
      title="AI改写"
      okText="改写内容"
      @cancel="previewVisible = false"
      @ok="onSubmit"
    >
      <div >
        <div class="editor-block" style="margin: 12px 0">
          <!--<MdEditor
            class="rewrite"
            ref="editorRefW"
            showToolbarName="true"
            v-model="domData.content"
            showAdjust="false"
            :preview="false"
            :toolbarsExclude="domData.arrs"
          />-->
        </div>
      </div>
     
      <template #footer >
        <div class="x-end">
          <Button class="button none" @click="previewVisible = false">取消</Button>
          <Button class="button" type="primary" @click="onOk">保存内容</Button>
          <Button class="button" type="primary" @click="getText">改写内容</Button>
        </div>
      </template>
    </Modal>
    <Modal
      :width="623"
      :visible="previewVisible2"
      title="AI改写"
      okText="改写内容"
      @cancel="previewVisible2 = false"
      @ok="onSubmit"
    >
      
      <div class="model-content">
        <div class="article flex-column">
          <div class="flex">
            <div style="width: 100px; text-align: right">原文：</div>
            <div class="flex1">{{ domData.selContent }}</div>
          </div>
          <div class="flex" style="margin-top: 30px">
            <div class="x-end" style="width: 100px; text-align: right" @click="onContinue">
              <img
                v-if="loading"
                class="rotate"
                src="@/assets/images/icon_loading@2x.png"
                style="width: 16px; height: 16px; margin-right: 8px"
              />
              <img
                v-else
                src="@/assets/images/ai_icon4_ck.png"
                style="width: 16px; height: 16px; margin-right: 8px"
              />
              <span>AI改写：</span>
            </div>
            <div class="flex1">{{ text }}</div>
          </div>
        </div>
      </div>
      
      <template #footer >
        <div class="x-end">
          <Button class="button none" @click="previewVisible2 = false">取消</Button>
          <Button class="button" v-if="!loading"  type="primary" @click="onSubmit">插入文章</Button>
        </div>
        <!-- <div class="x-end">
          <div class="tips"
            ><span style="color: #f53131">*</span>消耗{{ imagineNum.ai_word }}想象栗，当前剩余{{
              imagineNum.imagine_num
            }}想象栗</div
          >
        </div> -->
      </template>
    </Modal>
  </div>

</template>

<script>
  import { Modal, Button, message } from 'ant-design-vue';
  import defHttp from '@/jslibs/axios/http';
  // import { MdEditor } from 'md-editor-v3';

  export default {
    name: 'AIRewrite',
    components: {
      Modal,
      Button,
    },
    props: {
      content: String,
    },
    data() {
      return {
        type: 1,
        imagineNum: {},
        previewVisible: false,
        previewVisible2: false,
        loading: false,
        text: '',
        domData: {
          arrs: ['image', '=', 'pageFullscreen', 'fullscreen', 'htmlPreview', 'catalog', 'github'],
          selContent: '',
          content: '',
        },
      };
    },
    watch: {
      content: {
        handler(newVal, oldVal) {
          this.domData.content = this.content;
        },
        immediate: true,
      },
    },
    methods: {
      getText() {
        (this.$refs.editorRefW && this.$refs.editorRefW.insert) && this.$refs.editorRefW.insert((selectedText) => {
          this.domData.selContent = selectedText;
          return {
            targetValue: `${selectedText}`,
          };
        });
        if (!this.domData.selContent) {
          return message.warning(`请选中文本`);
        }
        // this.type = 2;
        this.previewVisible2 = true;
        this.$nextTick(() => {
          this.onContinue();
        });
        // this.onSubmit();
      },
      onShow() {
        this.previewVisible = true;
        this.domData.content = this.content;
        this.getImagineNum();
      },
      onHide() {
        this.previewVisible = false;
      },
      onContinue() {
        if (this.loading) return false;
        this.loading = true;
        defHttp
          .post({
            url: `/v1/cms/AiWordRewrite`,
            data: {
              content: this.domData.selContent,
            },
          })
          .then((res) => {
            this.loading = false;
            this.text = res.result.new_content;
            this.getImagineNum();
          })
          .catch(() => {
            this.loading = false;
          });
      },
      getImagineNum() {
        defHttp
          .get({
            url: `/v1/cms/GetImagineNum`,
          })
          .then((res) => {
            this.imagineNum = res.result;
          });
      },
      onSubmit() {
        // this.type = 1;
        this.previewVisible2 = false;
        this.$nextTick(() => {
          (this.$refs.editorRefW && this.$refs.editorRefW.insert) && this.$refs.editorRefW.insert((selectedText) => {
            /**
             * @return targetValue    待插入内容
             * @return select         插入后是否自动选中内容
             * @return deviationStart 插入后选中内容鼠标开始位置
             * @return deviationEnd   插入后选中内容鼠标结束位置
             */
            return {
              targetValue: `${this.text}`,
              select: true,
              deviationStart: 0,
              deviationEnd: 0,
            };
          });
        });
      },
      onOk() {
        this.$emit('onAiRewrite', `${this.domData.content}`);
      },
    },
  };
  // console.log(content2, '--------------------------------')
</script>
<style lang="less">
.md-editor-toolbar-wrapper{
    /* display: none; */
  }

  .rewrite{
  .md-editor-toolbar-wrapper{
    display: none;
    border:none !important;
  }

  .md-editor-footer{
    display: none;
  }
  // .md-editor{
  //   border:none !important;
  // }
  .md-editor {
    border:0;
  }
  // .cm-editor{
  //   font-size:16px;
  //   padding-top:10px;
  // }
  // .cm-scroller{
  //   overflow-y:auto !important;
  // }
  // .cm-scroller .cm-content{
  //   margin: 0px 60px !important;
  // }
}
</style>
<style lang="less" scoped>
  
  .model-content {
    padding: 24px;
  }

  .article {
    padding: 20px 30px;
    color: #222;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    .nav-item {
      min-width: 90px;
      height: 32px;
      margin-right: 12px;
      padding: 0 10px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      &.active {
        border: 1px solid #000;
        background: #7472f6;
      }
    }
  }

  .tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }
</style>
